import _ from "lodash";
import React, { useState, useReducer, useEffect } from "react";
import { connect } from "react-redux";
import { graphql, compose } from "lib/apolloClient";
import classes from "./SubjectCategory.scss";
import { Button, EmptyState, Modal } from "@toddle-edu/ds-web";
import CategoryTemplate from "./CategoryTemplate";
import { goToRelativeRoute } from "modules/Services";
import { getCurrentAcademicYear } from "modules/CommonSelectors";
import { setToastMsg } from "routes/modules/LoginModule";
import { getGlobalHeaderWiseScreenRevampStatus } from "Course/modules/CourseModule";
import {
  addScoreCategoryTemplateNode,
  deleteScoreCategoryTemplateNode,
  updateScoreCategoryTemplateNode,
  checkTemplateObjError,
  getHierarchy,
  checkTotalPercentageWeight,
  getHierarchyRoute,
  getUnusedColor,
  areAllCoursesUsed,
  getAssessmentCategorySetStructure,
  getIsCategorySetUpdated,
  getIsCategorySetNotEmpty,
} from "ScoreCategories/modules/ScoreCategoriesModule";
import withLoader from "UIComponents/GqlWithLoader";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import BreadCrumbs from "AppComponents/BreadCrumbs";
import { NoCategorySetPointBasedAssessmentsIllustration } from "@toddle-edu/ds-theme";
import { useI18n } from "Hooks";
import {
  getOrganizationPointSetQuery,
  getSubjectBasedCoursesQuery,
} from "ScoreCategories/modules/ScoreCategoriesQueries";
import {
  getOrganizationPointSetFromCache,
  getSubjectBasedCoursesFromCache,
} from "ScoreCategories/modules/ScoreCategoriesGraphqlHelpers";
import { getAdminSetupFiltersByEntityTypeMemoized } from "Administrator/modules/Utils";
import { getOrganizationGradeBasicDetailsQuery } from "modules/CommonQuery";
import { getOrganizationBasicGradeDetailsFromCache } from "modules/CommonGraphqlHelpers";
import { getCurriculumProgramLabel } from "Platform/modules/PlatformUtils";
import {
  getGradeCalculationMethodCategory,
  getGradeCalculationWeightageTypeSetting,
  checkIsAssessmentSetupV2Enabled,
  getGradeCalculationMethodSetting,
} from "routes/routes/Administrator/routes/DPAcademicSetup/routes/AssessmentSetup/modules/utils";
import { getSettingValue } from "modules/PermissionModule";
import CreateTemplate from "../routes/CreateTemplate/components/CreateTemplate";
import classNames from "classnames";
import { getLabelWithArchivedText } from "Utils";
import AssessmentCategoriesDeleteModal from "ScoreCategories/components/AssessmentCategoriesDeleteModal";
import ResetOverridenCategoryScoreWarningModal from "GradingSetup/routes/AssessmentCategorySetup/components/AssessmentCategorySetupConfiguration/ResetOverridenCategoryScoreWarningModal";
import {
  getTemplateLabelFromId,
  initialState as scoreCategoriesInitialState,
  scoreCategoriesReducer,
  UPDATE_TEMPLATE_FIELD_VALUE,
  INIT_TEMPLATE_FIELDS_SET,
  UPDATE_TEMPLATE_FIELDS_SET,
  SET_IS_EDIT_TEMPLATE_MODE,
  SET_USED_COURSES,
  SET_USED_CATEGORY_SET_NAMES,
  UPDATE_CURRENT_CATEGORY_GRADE_BOUNDARY_VALUES,
  UPDATE_OVERALL_CATEGORY_GRADE_BOUNDARY_VALUES,
} from "ScoreCategories/modules/Utils";
import {
  USE_WEIGHTAGE_FOR_CATEGORY_SETTING,
  getIsNewAssessmentSettingsEnabled,
  getCanDefineGradeBoundary,
  FINAL_GRADE_CALCULATION_SETTING,
  getShowCategoryGradeBoundaryToggle,
  getOrderedOrganizationPointSet,
  OVERRIDE_FINAL_GRADE_SETTING,
  CATEGORY_FINAL_SCORE_DISPLAY_TYPE_SETTING,
} from "GradingSetup/modules/Utils";
import { withRouter } from "react-router";
import { getIsGradingPeriodUnlocked } from "Login/routes/Administrator/commonComponents/GradingSetup/modules/Utils";

import { canManageAssessmentCategories } from "Settings/modules/SettingsUtils";
import { Trans } from "react-i18next";

const components = { b: <b /> };

const shiftEnterShortcut = { code: "Enter", shiftKey: true };

const SubjectCategory = props => {
  const {
    goToRelativeRoute,
    rootNodes,
    termId,
    subjectId,
    gradeId,
    curriculumProgramId,
    isEditMode,
    setIsEditMode,
    templateFieldsObj,
    updateTemplateFieldValue,
    updateTemplateFieldsSet,
    updateScoreCategoryTemplateNode,
    setUsedCourses,
    curriculumType,
    organizationPointSet: _organizationPointSet,
    organizationPointSetCount,
    usedCategorySetNames,
    setUsedCategorySetNames,
    subjectBasedCourses,
    usedCourses,
    grades,
    isCourseApplicableToCategorySet,
    curriculumProgramTitle,
    isScoreV2,
    weightageType,
    subject,
    isTemplateRoute,
    updateCategoryGradeBoundaryValues,
    currentCategoryGradeBoundaryValues,
    overallCategoryGradeBoundaryValues,
    scoreBasedAssessmentVariables,
    pointSetVariables,
    currentDialogueAction,
    setCurrentDialogueAction,
    isClassSettingsContext = false,
    setClassSettingMode,
    classSettingMode,
    assessmentCategoryId,
    selectedGrade,
    editAssessmentCategoryModalTitle,
    terms,
    subjectGroups,
    showConfigureCategoriesModal,
    setShowConfigureCategoriesModal,
    closeConfigureCategoriesModalOnSave,
    alertText,
    isAssessmentSetupV2Enabled,
    finalGradeCalculationType,
    selectedTerms,
    setSelectedTerms,
    usedTerms = [],
    primaryGradeId,
    isAdmin = false,
    defaultGradeScaleSet,
    isWeightageEnabledForCategory,
    isNewAssessmentSettingsEnabled,
    canDefineGradeBoundary,
    finalGradeCalculationMethod,
    gradeCalculationMethod,
    updateCurrentCategoryGradeBoundaryValues,
    updateOverallCategoryGradeBoundaryValues,
    canOverrideFinalGrade,
    route,
    router: { setRouteLeaveHook },
    portalType,
    categoryTotalDisplayType,
    students,
    showUpdatedDesign = false,
  } = props;

  useEffect(() => {
    if (route) {
      const removeRouteLeaveHook = setRouteLeaveHook(route, nextLocation => {
        const isTemplateRoute = _.includes(location?.pathname, "template");
        if (
          isTemplateRoute &&
          currentDialogueAction?.action !== "PENDING_CHANGES"
        ) {
          let shouldShowDialogue = false;

          if (_.get(templateFieldsObj, "id")) {
            const isSetUpdated = getIsCategorySetUpdated({
              pointSetVariables,
              templateFieldsObj,
              isCourseApplicableToCategorySet,
            });
            if (isSetUpdated) {
              shouldShowDialogue = true;
            }
          } else if (getIsCategorySetNotEmpty({ templateFieldsObj })) {
            shouldShowDialogue = true;
          }

          if (shouldShowDialogue) {
            setCurrentDialogueAction({
              action: "PENDING_CHANGES",
              params: { pathname: nextLocation?.pathname },
            });
            return false;
          }
        }
      });

      return removeRouteLeaveHook;
    }
  }, [
    route,
    subjectId,
    setRouteLeaveHook,
    templateFieldsObj,
    pointSetVariables,
    currentDialogueAction,
    setCurrentDialogueAction,
    isCourseApplicableToCategorySet,
  ]);

  const organizationPointSet = _.orderBy(
    _organizationPointSet,
    ({ node }) =>
      getOrderedOrganizationPointSet({
        node,
        grades,
      }),
    "asc"
  );

  const SL_HL_GENERIC_TAGS = ["SL", "HL"];
  const subjectType = _.get(subject, "type");
  const flatVariants = _.get(subject, "flatVariants", []);
  const subjectLevelGenericTags = !_.isEmpty(subject)
    ? _.orderBy(
        _.filter(
          _.uniqBy(
            _.map(flatVariants, item => _.get(item, "level")),
            "id"
          ),
          tag => _.includes(SL_HL_GENERIC_TAGS, _.get(tag, "label", ""))
        ),
        "label",
        "desc"
      )
    : _.map(SL_HL_GENERIC_TAGS, tag => ({ label: tag }));

  const { t } = useI18n([
    "common",
    "classRoom",
    "teacherHomePage",
    "academicSetup",
    "assessmentEvaluation",
    "community",
  ]);

  const [templateId, setTemplateId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [areNotValid, setAreNotValid] = useState({});
  const [showDialogueBox, setShowDialogueBox] = useState(false);

  const isorganizationPointSet = organizationPointSetCount > 0;
  const isAbsoluteWeightageType = _.isEqual(weightageType, "ABSOLUTE");
  const isIBGradeCalculationTypeSelected =
    isAssessmentSetupV2Enabled && finalGradeCalculationType === "IB_GRADE";
  const isScoreCalculationTypeSelected =
    isAssessmentSetupV2Enabled && finalGradeCalculationType === "SCORE";
  const isGradingPeriodUnlocked = getIsGradingPeriodUnlocked(
    _.find(terms, { id: termId })
  );

  const [overriddenCategories, setOverriddenCategories] = useState([]);

  //Function to create a new template
  const onClickAddTemplate = () => {
    const { initTemplateFieldsSet, setToastMsg } = props;

    if (
      isCourseApplicableToCategorySet &&
      areAllCoursesUsed({
        organizationPointSet,
        courses: _.get(subjectBasedCourses, "courses.edges", []),
        courseType: "Course",
        idPath: "node.id",
      })
    ) {
      const areNoCoursesAssociated = _.isEmpty(
        _.get(subjectBasedCourses, "courses.edges", [])
      );

      setToastMsg({
        msg: areNoCoursesAssociated
          ? "toastMsgs:no_class_associated_with_subject_msg"
          : "toastMsgs:subject_based_courses_used",
        locale_params: [
          { key: "label", value: subjectName, isPlainText: true },
        ],
        timeOut: 10000,
        type: "warning",
        position: "toast-top-center",
      });
      return;
    } else if (
      !isCourseApplicableToCategorySet &&
      areAllCoursesUsed({
        organizationPointSet,
        courses: grades,
        courseType: "Grade",
        idPath: "id",
      })
    ) {
      const areNoCoursesAssociated = _.isEmpty(grades);

      setToastMsg({
        msg: areNoCoursesAssociated
          ? "toastMsgs:no_grade_associated_with_subject_msg"
          : "toastMsgs:subject_based_grades_used",
        locale_params: [
          { key: "label", value: subjectName, isPlainText: true },
        ],
        timeOut: 10000,
        type: "warning",
        position: "toast-top-center",
      });
      return;
    }

    setIsEditMode(false);
    initTemplateFieldsSet(); //Function to intialize category set object
    if (isClassSettingsContext) {
      setClassSettingMode({
        assessmentCategoryId,
        isEditing: true,
      });
    } else {
      goToRelativeRoute({ route: "./template" });
    }
  };

  const getAssessmentCategories = () => {
    const organizationPointSetNode = _.find(
      organizationPointSet,
      organizationPointSetObj =>
        _.get(organizationPointSetObj, "node.id") === templateFieldsObj?.id
    );
    const assessmentCategories = _.get(
      organizationPointSetNode,
      "node.categories"
    );

    return assessmentCategories;
  };

  const getEditedCategoryIds = () => {
    const editedCategoriesIds = [];
    const assessmentCategories = getAssessmentCategories();

    _.forEach(assessmentCategories, category => {
      const { slWeight, hlWeight, id } = category;
      const { fieldValues } = templateFieldsObj;

      const fieldValue = _.find(
        fieldValues,
        fieldValue => fieldValue.id === id
      );

      const { hlWeight: fieldHlWeight, slWeight: fieldSlWeight } =
        fieldValue || {};

      if (
        fieldValue &&
        (slWeight != fieldSlWeight || hlWeight != fieldHlWeight)
      ) {
        editedCategoriesIds.push(category.id);
      }
    });
    return editedCategoriesIds;
  };

  const getOverridenCategories = () => {
    if (categoryTotalDisplayType !== "WEIGHT") return null;

    const editedCategoryIds = getEditedCategoryIds();

    const editedAssignments = [];
    const assessmentCategories = getAssessmentCategories();

    _.forEach(editedCategoryIds, categoryId => {
      _.find(assessmentCategories, category => {
        const { overridenCategoryScoresCount, id, label } = category;

        if (categoryId === id && overridenCategoryScoresCount > 0) {
          editedAssignments.push({ id, label });
          return true;
        }
      });
    });
    return editedAssignments;
  };

  const onClickSaveHandler = () => {
    const overriddenCategories = getOverridenCategories();
    if (_.isEmpty(overriddenCategories)) handleSave();
    else setOverriddenCategories(overriddenCategories);
  };

  const singleOverriddenCategory = overriddenCategories?.length === 1;
  const overridenCategoryLabel = _.get(overriddenCategories, "0.label");

  const headerText = singleOverriddenCategory
    ? t("academicSetup:change_label_weight", {
        label: overridenCategoryLabel,
      })
    : t("academicSetup:change_category_weights");

  const bodyText = singleOverriddenCategory ? (
    <Trans
      i18nKey="academicSetup:changing_weight_will_reset_all_overriden_scores"
      components={components}
      values={{ label: overridenCategoryLabel }}
    >
      Please note that changing the weight for ‘
      {{ label: overridenCategoryLabel }}’ category will
      <b>
        reset all overridden ‘{{ label: overridenCategoryLabel }}’ scores to
        their calculated values in unlocked gradebooks and progress reports.
        This action cannot be undone.
      </b>
      Would you still like to continue?
    </Trans>
  ) : (
    <Trans
      i18nKey="academicSetup:changing_the_weights_for_categories_will_reset_all_overriden_category_scores"
      components={components}
    >
      Please note that changing the weights for the categories will
      <b>
        reset all overridden category scores to their calculated values in
        unlocked gradebooks and progress reports. This action cannot be undone.
      </b>
      Would you still like to continue?
    </Trans>
  );

  const checkboxText = singleOverriddenCategory ? (
    <Trans
      i18nKey="academicSetup:overriden_scores_will_be_reset_to_their_calculated_values"
      components={components}
      values={{ label: overridenCategoryLabel }}
    >
      I understand that
      <b>
        all overridden ‘{{ label: overridenCategoryLabel }}’ scores will be
        reset to their calculated values.
      </b>
    </Trans>
  ) : (
    <Trans
      i18nKey="academicSetup:understand_that_all_overriden_category_scores_will_be_reset_to_their_calculated_values"
      components={components}
    >
      I understand that
      <b>
        all overridden category scores will be reset to their calculated values.
      </b>
    </Trans>
  );

  /* Function to update the template when in Edit Mode and create the template
  when isEditMode is false */
  const onClickSave = async ({ id, overridenCategories }) => {
    const { addScoreCategoryTemplateNode, setToastMsg } = props;

    const isCurriculumDP = curriculumType === "IB_DP";
    const isIBGradeCalculationTypeSelected =
      isAssessmentSetupV2Enabled && finalGradeCalculationType === "IB_GRADE";

    let errorCount = checkTemplateObjError({
      templateFieldsObj,
      setAreNotValid,
      areNotValid,
      curriculumType,
      subjectLevelGenericTags,
      excludeWeightCheck:
        isIBGradeCalculationTypeSelected || !isWeightageEnabledForCategory,
    });

    const skipPercentageCheck =
      (isScoreV2 && isAbsoluteWeightageType) ||
      isAssessmentSetupV2Enabled ||
      isNewAssessmentSettingsEnabled;

    if (!skipPercentageCheck) {
      let totalPercentageWeight = 0;
      if (isCurriculumDP && !_.isEmpty(subjectLevelGenericTags)) {
        totalPercentageWeight = _.sum(
          _.map(subjectLevelGenericTags, tag => {
            const tagLabel = _.get(tag, "label", "");
            return _.isEqual(tagLabel, "SL")
              ? checkTotalPercentageWeight({
                  templateFieldsObj,
                  weightKey: "slWeight",
                })
              : checkTotalPercentageWeight({
                  templateFieldsObj,
                  weightKey: "hlWeight",
                });
          })
        );
      } else {
        totalPercentageWeight = checkTotalPercentageWeight({
          templateFieldsObj,
          weightKey: "percentage_weight",
        });
      }

      if (
        totalPercentageWeight !=
        (isCurriculumDP && _.size(subjectLevelGenericTags) > 1 ? 200 : 100)
      ) {
        if (errorCount === 0) {
          setToastMsg({
            msg: "academicSetup:category_set_header_subtext",
            type: "warning",
            position: "toast-top-center",
          });
          return;
        } else {
          errorCount = errorCount + 1;
        }
      }
    }

    if (errorCount > 0) {
      setToastMsg({
        msg: "toastMsgs:rectify_errors_with_count",
        locale_params: [{ key: "count", value: errorCount, isPlainText: true }],
        type: "warning",
        position: "toast-top-center",
      });
      return;
    }

    if (_.includes(usedCategorySetNames, templateFieldsObj.label)) {
      setToastMsg({
        msg: "toastMsgs:category_set_name_warning_label",
        locale_params: [
          { key: "label", value: templateFieldsObj?.label, isPlainText: true },
        ],
        type: "warning",
        position: "toast-top-center",
      });
      return;
    }

    const scoreCategorySet = _.get(
      _.find(organizationPointSet, ({ node }) => node.id === id),
      "node",
      {}
    );
    setIsLoading(true);
    try {
      if (isEditMode) {
        await updateScoreCategoryTemplateNode({
          variables: pointSetVariables,
          templateFieldsObj,
          curriculumProgramId,
          curriculumType,
          subjectLevelGenericTags,
          scoreCategorySet,
          subjectId,
          isCourseApplicableToCategorySet,
          portalType,
          overriddenCategories,
        });
      } else {
        await addScoreCategoryTemplateNode({
          variables: pointSetVariables,
          templateFieldsObj,
          curriculumProgramId,
          curriculumType,
          subjectLevelGenericTags,
          termId,
          subjectId,
          isCourseApplicableToCategorySet,
          scoreBasedAssessmentVariables,
          isScoreV2,
          portalType,
        });
      }
      setToastMsg({
        msg: isEditMode
          ? "toastMsgs:category_set_successfully_updated"
          : "toastMsgs:category_set_successfully_created",
        type: "success",
      });
      setAreNotValid({});
      if (isClassSettingsContext) {
        setClassSettingMode({
          isEditing: false,
          assessmentCategoryId: "",
        });
        if (showConfigureCategoriesModal) {
          closeConfigureCategoriesModalOnSave();
        }
      } else {
        goToRelativeRoute({ route: "../" });
      }
    } catch (e) {
      if (e.networkError) {
        setToastMsg("toastMsgs:no_internet_connection");
      } else {
        setToastMsg("toastMsgs:something_went_wrong");
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Funtion to delete the template
  const onClickDeleteTemplate = async ({
    templateId,
    isGradeBoundary = false,
  }) => {
    const { deleteScoreCategoryTemplateNode, setToastMsg } = props;
    setIsLoading(true);
    try {
      await deleteScoreCategoryTemplateNode({
        variables: pointSetVariables,
        templateId,
        scoreBasedAssessmentVariables,
        isScoreV2,
        portalType,
      });
      if (!isGradeBoundary) {
        setToastMsg({
          msg: "toastMsgs:category_set_successfully_deleted",
          type: "success",
        });
        if (isTemplateRoute) {
          goToRelativeRoute({ route: "../" });
        }
      }
      return { success: true };
    } catch (e) {
      if (e.networkError) {
        setToastMsg("toastMsgs:no_internet_connection");
      } else {
        setToastMsg("toastMsgs:something_went_wrong");
      }
    } finally {
      if (showDialogueBox) {
        setShowDialogueBox(false);
      }
      setIsLoading(false);
    }
  };

  //Funtion to edit a existing template, the data for the template to edited get stored in redux state
  const onClickEditTemplate = id => {
    const scoreCategorySet = _.get(
      _.find(organizationPointSet, ({ node }) => node.id === id),
      "node",
      {}
    );

    const set = getAssessmentCategorySetStructure({
      scoreCategorySet,
      isCourseApplicableToCategorySet,
    });
    updateTemplateFieldsSet(set);
    setTemplateId(id);
  };

  const updateTemplateField = ({ params, index }) => {
    const {
      templateFieldsObj: { fieldValues },
    } = props;
    let fieldValue = fieldValues[index];
    fieldValue = { ...fieldValue, ...params };

    updateTemplateFieldValue({
      type: "update",
      index,
      data: fieldValue,
    });
  };

  const deleteTemplateFieldValue = ({ index }) => {
    setAreNotValid({});
    updateTemplateFieldValue({ type: "delete", index });
  };

  const handleSave = () => {
    onClickSave({
      id: _.get(templateFieldsObj, "id", ""),
      overriddenCategories,
    });
  };

  const onCloseModal = () => {
    setOverriddenCategories([]);
  };

  const onClose = () => {
    setAreNotValid({});
    setClassSettingMode({
      isEditing: false,
      assessmentCategoryId: "",
    });
    if (showConfigureCategoriesModal) {
      setShowConfigureCategoriesModal(false);
    }
  };

  const addTemplateFieldValue = () => {
    const previousDisplaySequence = _.get(
      _.last(templateFieldsObj.fieldValues),
      "displaySequence",
      1
    );
    updateTemplateFieldValue({
      type: "add",
      data: {
        id: null,
        label: "",
        percentage_weight: "",
        hlWeight: "",
        slWeight: "",
        color: getUnusedColor({ fieldValues: templateFieldsObj.fieldValues }),
        displaySequence: previousDisplaySequence + 1,
        gradeScaleType: null,
        gradeBoundaryId: null,
      },
    });
  };

  const renderHeadingButtonContainer = (
    <div className={classes.buttonContainer}>
      <Button
        _legacy_size="large"
        size="medium"
        onClick={onClickAddTemplate}
        variant={isorganizationPointSet ? "primary" : "destructive"}
        disabled={!isGradingPeriodUnlocked}
      >
        {t("classRoom:add_a_category_set")}
      </Button>
    </div>
  );

  const subjectName = _.get(
    _.find(rootNodes, node => node.id == subjectId),
    "name"
  );

  const isArchived = _.get(
    _.find(rootNodes, node => node.id == subjectId),
    "isArchived",
    false
  );

  const emptyStateContainerStyle = classNames({
    [classes.emptyStateContainer]: true,
    [classes.classSettingEmptyStateContainer]: isClassSettingsContext,
  });

  const classSettingsEditModeEnabled =
    (assessmentCategoryId === classSettingMode?.assessmentCategoryId &&
      isClassSettingsContext &&
      classSettingMode?.isEditing) ||
    showConfigureCategoriesModal;

  const isTeacherAllowedToAddEditCategories =
    canManageAssessmentCategories() || !isClassSettingsContext;

  const isTeacherAllowedToAddEditCategoriesWithLockedTermCheck =
    isTeacherAllowedToAddEditCategories && isGradingPeriodUnlocked;

  const emptyStateSubtitle = isTeacherAllowedToAddEditCategoriesWithLockedTermCheck
    ? t("academicSetup:point_based_assessment_empty_subtext", {
        label: subjectName,
      })
    : t("schoolSetup:once_school_admin_creates_category_set");

  const showCategoryGradeBoundaryToggle = getShowCategoryGradeBoundaryToggle({
    curriculumType,
    curriculumProgramId,
    subjectType,
    finalGradeCalculationMethod,
    canOverrideFinalGrade,
  });

  const childProps = {
    templateId,
    isEditMode,
    deleteTemplateFieldValue,
    addTemplateFieldValue,
    updateTemplateField,
    templateFieldsObj,
    onClickDeleteTemplate,
    updateTemplateFieldsSet,
    onClickSave,
    isLoading,
    termId,
    subjectId,
    gradeId,
    setUsedCourses,
    organizationPointSet,
    subjectName,
    goToRelativeRoute,
    areNotValid,
    setAreNotValid,
    curriculumType,
    subjectBasedCourses,
    usedCourses,
    setUsedCategorySetNames,
    grades,
    subject,
    isCourseApplicableToCategorySet,
    curriculumProgramId,
    curriculumProgramTitle,
    isAbsoluteWeightageType,
    subjectLevelGenericTags,
    updateCategoryGradeBoundaryValues,
    currentCategoryGradeBoundaryValues,
    overallCategoryGradeBoundaryValues,
    setShowDialogueBox,
    setCurrentDialogueAction,
    pointSetVariables,
    isIBGradeCalculationTypeSelected,
    isScoreCalculationTypeSelected,
    defaultGradeScaleSet,
    isWeightageEnabledForCategory,
    isNewAssessmentSettingsEnabled,
    canDefineGradeBoundary,
    finalGradeCalculationMethod,
    showCategoryGradeBoundaryToggle,
    gradeCalculationMethod,
    isAdmin,
    updateCurrentCategoryGradeBoundaryValues,
    updateOverallCategoryGradeBoundaryValues,
    categoryTotalDisplayType,
    onCloseModal,
    overriddenCategories,
    onClickSaveHandler,
    handleSave,
    headerText,
    bodyText,
    checkboxText,
  };

  const templateLabel = getTemplateLabelFromId({
    id: templateId || templateFieldsObj?.id,
    organizationPointSet,
  });

  const isGlobalHeaderEnabled = getGlobalHeaderWiseScreenRevampStatus();

  const footerButtonContainerClasses = classNames({
    [classes.footerButtonContainer]: !showUpdatedDesign,
    [classes.footerButtonContainerV2]: showUpdatedDesign,
  });

  return (
    <React.Fragment>
      {props.children && !isClassSettingsContext ? (
        React.cloneElement(props.children, childProps)
      ) : classSettingsEditModeEnabled ? (
        <Modal
          shouldCloseOnEsc={true}
          shouldCloseOnOverlayClick={true}
          hasOverlay={true}
          onClose={onClose}
          width={showUpdatedDesign ? "75vw" : "80vw"}
          height={showUpdatedDesign ? "80vh" : "90vw"}
          dsVersion={showUpdatedDesign ? "2.0" : "1.0"}
        >
          <Modal.Header
            hasSeparator={!showUpdatedDesign}
            title={editAssessmentCategoryModalTitle}
          />
          <Modal.Body isScrollable={true}>
            <CreateTemplate
              {...childProps}
              isClassSettingsContext={isClassSettingsContext}
              setClassSettingMode={setClassSettingMode}
              selectedGrade={selectedGrade}
              alertText={alertText}
              portalType={portalType}
              showUpdatedDesign={showUpdatedDesign}
            />
            {!_.isEmpty(overriddenCategories) ? (
              <ResetOverridenCategoryScoreWarningModal
                headerText={headerText}
                bodyText={bodyText}
                checkboxText={checkboxText}
                onClose={onCloseModal}
                onSubmit={handleSave}
              />
            ) : null}
          </Modal.Body>
          <Modal.Footer hasSeparator={true}>
            <div className={classes.footer}>
              <div className={footerButtonContainerClasses}>
                <Button
                  dsVersion={isGlobalHeaderEnabled ? "2.0" : "1.0"}
                  variant={
                    isGlobalHeaderEnabled ? "neutral" : "outlined-subtle"
                  }
                  type={isGlobalHeaderEnabled ? "outlined" : undefined}
                  _legacy_size="large"
                  size="medium"
                  onClick={onClose}
                >
                  {t("common:cancel")}
                </Button>
                <Button
                  dsVersion={isGlobalHeaderEnabled ? "2.0" : "1.0"}
                  variant="progressive"
                  _legacy_size="large"
                  size="medium"
                  onClick={onClickSaveHandler}
                  shortcut={
                    isGlobalHeaderEnabled ? shiftEnterShortcut : undefined
                  }
                >
                  {isEditMode ? t("common:save") : t("common:add")}
                </Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      ) : (
        <div className={classes.container}>
          {isClassSettingsContext ? null : (
            <div className={classes.headingContainer}>
              <div>
                {!isScoreV2 && (
                  <BreadCrumbs
                    hierarchy={getHierarchy({
                      slice: 3,
                      t,
                      curriculumProgramId,
                      curriculumProgramTitle,
                    })}
                    onHierarchyClick={({ id }) => {
                      goToRelativeRoute({
                        route: getHierarchyRoute({
                          id,
                          curriculumType,
                          curriculumProgramId,
                        }),
                        type: "replace",
                        replacePath: "administrator",
                      });
                    }}
                  />
                )}
                <div className={classes.headerText}>
                  {getLabelWithArchivedText({
                    t,
                    isArchived,
                    label: subjectName,
                  })}
                </div>
                <div className={classes.headerSubText}>
                  {t(
                    "academicSetup:create_category_sets_for_different_grades_of_subject"
                  )}
                </div>
              </div>
              {isorganizationPointSet && isGradingPeriodUnlocked
                ? renderHeadingButtonContainer
                : null}
            </div>
          )}
          {isorganizationPointSet ? (
            _.map(organizationPointSet, templateNode => (
              <CategoryTemplate
                goToRelativeRoute={goToRelativeRoute}
                isTeacherAllowedToAddEditCategories={
                  isTeacherAllowedToAddEditCategories
                }
                isGradingPeriodUnlocked={isGradingPeriodUnlocked}
                templateNode={_.get(templateNode, "node", {})}
                setIsEditMode={setIsEditMode}
                onClickEditTemplate={onClickEditTemplate}
                subjectId={subjectId}
                curriculumType={curriculumType}
                isCourseApplicableToCategorySet={
                  isCourseApplicableToCategorySet
                }
                isAbsoluteWeightageType={isAbsoluteWeightageType}
                subjectLevelGenericTags={subjectLevelGenericTags}
                setTemplateId={setTemplateId}
                setShowDialogueBox={setShowDialogueBox}
                curriculumProgramId={curriculumProgramId}
                termId={termId}
                grades={grades}
                rootNodes={rootNodes}
                subjectType={subjectType}
                pointSetVariables={pointSetVariables}
                scoreBasedAssessmentVariables={scoreBasedAssessmentVariables}
                subjectName={subjectName}
                organizationPointSet={organizationPointSet}
                setClassSettingMode={setClassSettingMode}
                isClassSettingsContext={isClassSettingsContext}
                assessmentCategoryId={assessmentCategoryId}
                terms={terms}
                subjectGroups={subjectGroups}
                selectedTerms={selectedTerms}
                setSelectedTerms={setSelectedTerms}
                usedTerms={usedTerms}
                primaryGradeId={primaryGradeId}
                defaultGradeScaleSet={defaultGradeScaleSet}
                isWeightageEnabledForCategory={isWeightageEnabledForCategory}
                isNewAssessmentSettingsEnabled={isNewAssessmentSettingsEnabled}
                currentCategoryGradeBoundaryValues={
                  currentCategoryGradeBoundaryValues
                }
                overallCategoryGradeBoundaryValues={
                  overallCategoryGradeBoundaryValues
                }
                updateCurrentCategoryGradeBoundaryValues={
                  updateCurrentCategoryGradeBoundaryValues
                }
                updateOverallCategoryGradeBoundaryValues={
                  updateOverallCategoryGradeBoundaryValues
                }
                canOverrideFinalGrade={canOverrideFinalGrade}
                showUpdatedDesign={showUpdatedDesign}
              />
            ))
          ) : (
            <div className={emptyStateContainerStyle}>
              <EmptyState
                illustration={NoCategorySetPointBasedAssessmentsIllustration}
                title={t("classRoom:nothing_here_yet")}
                subtitle={emptyStateSubtitle}
                primaryButton={
                  isTeacherAllowedToAddEditCategories
                    ? renderHeadingButtonContainer
                    : null
                }
              />
            </div>
          )}
        </div>
      )}
      {showDialogueBox && (
        <AssessmentCategoriesDeleteModal
          itemId={templateId || templateFieldsObj?.id}
          closeModal={() => setShowDialogueBox(false)}
          onClickDelete={onClickDeleteTemplate}
          itemLabel={templateLabel}
          itemType={"CATEGORY_SET"}
          portalType={portalType}
        />
      )}
      {showDialogueBox && isLoading ? (
        <FullScreenLoader overlayContainer={classes.overlayContainer} />
      ) : null}
    </React.Fragment>
  );
};

const mapActionCreators = {
  goToRelativeRoute,
  setToastMsg,
  addScoreCategoryTemplateNode,
  deleteScoreCategoryTemplateNode,
  updateScoreCategoryTemplateNode,
};

const mapStateToProps = (state, ownProps) => {
  const {
    curriculumProgramId,
    curriculumType,
    params,
    isScoreV2,
    location: { pathname } = {},
    isEditMode,
    templateFieldsObj,
    usedCategorySetNames,
    usedCourses,
    subject,
    primaryGradeId,
    selectedGrade,
  } = ownProps;
  const termId = _.get(params, "termId") || ownProps.termId;
  const organizationId = _.get(state, "login.userInfo.org_id");
  const subjectId =
    ownProps.subjectId || _.get(ownProps, "routeParams.subject_id");

  const academicYearSelected = _.get(
    state,
    "platform.academicYearSelected",
    {}
  );
  const currentAcademicYear = getCurrentAcademicYear({
    organizationId,
  });
  const academicYearSelectedId = _.get(academicYearSelected, "id", null);
  const currentAcademicYearId = _.get(currentAcademicYear, "id", null);

  const gradeFilters = getAdminSetupFiltersByEntityTypeMemoized({
    curriculumProgramId,
    type: "GRADE",
  });

  const curriculumPrograms = _.get(
    state,
    "platform.organizationCurriculumPrograms",
    []
  );

  const curriculumProgramTitle = getCurriculumProgramLabel({
    curriculumPrograms,
    curriculumProgramId,
    shouldIncludeAcronym: true,
  });

  const isTemplateRoute = _.includes(pathname, "template");

  const weightageTypeSettingName = getGradeCalculationWeightageTypeSetting({
    curriculumType,
  });

  const weightageType = getSettingValue({
    name: weightageTypeSettingName,
    currentCurriculumProgramId: curriculumProgramId,
  });

  const categoryTotalDisplayType = getSettingValue({
    name: CATEGORY_FINAL_SCORE_DISPLAY_TYPE_SETTING,
    currentCurriculumProgramId: curriculumProgramId,
  });

  const isAssessmentSetupV2Enabled = checkIsAssessmentSetupV2Enabled();
  const finalGradeCalculationType = getSettingValue({
    name: "FinalGradeCalculationSetting",
    currentCurriculumProgramId: curriculumProgramId,
  });

  const isNewAssessmentSettingsEnabled = getIsNewAssessmentSettingsEnabled();
  const isWeightageEnabledForCategory = isNewAssessmentSettingsEnabled
    ? getSettingValue({
        name: USE_WEIGHTAGE_FOR_CATEGORY_SETTING,
        currentCurriculumProgramId: curriculumProgramId,
      })
    : true;

  // * used for edit template
  const selectedGradeId = _.get(selectedGrade, "value");
  // * used for create template
  const selectedTemplateGradeId = _.first(_.get(templateFieldsObj, "courses"));
  const gradeId = primaryGradeId || selectedGradeId || selectedTemplateGradeId;

  const canDefineGradeBoundary = getCanDefineGradeBoundary({
    curriculumProgramId,
    isScoreV2,
    curriculumType,
    subjectType: _.get(subject, "type"),
    gradeId,
  });

  const finalGradeCalculationMethod = getSettingValue({
    name: FINAL_GRADE_CALCULATION_SETTING,
    currentCurriculumProgramId: curriculumProgramId,
    gradeId,
  });
  const gradeCalculationMethodSettingName = getGradeCalculationMethodSetting({
    curriculumType,
  });

  const gradeCalculationMethod = getSettingValue({
    name: gradeCalculationMethodSettingName,
    currentCurriculumProgramId: curriculumProgramId,
  });

  const canOverrideFinalGrade = getSettingValue({
    name: OVERRIDE_FINAL_GRADE_SETTING,
    currentCurriculumProgramId: curriculumProgramId,
  });

  return {
    subjectBasedCoursesVariables: {
      id: organizationId,
      filters: {
        academicYears: academicYearSelectedId
          ? academicYearSelectedId
          : currentAcademicYearId,
        curriculumProgramIds: curriculumProgramId,
      },
    },
    termId,
    subjectId,
    isEditMode,
    templateFieldsObj,
    usedCategorySetNames,
    usedCourses,
    gradeFilters,
    organizationId,
    curriculumProgramId,
    curriculumProgramTitle,
    isTemplateRoute,
    platform: "ADMIN",
    categories: [getGradeCalculationMethodCategory({ curriculumType })],
    weightageType,
    weightageTypeSettingName,
    isAssessmentSetupV2Enabled,
    finalGradeCalculationType,
    isWeightageEnabledForCategory,
    isNewAssessmentSettingsEnabled,
    canDefineGradeBoundary,
    finalGradeCalculationMethod,
    gradeCalculationMethod,
    canOverrideFinalGrade,
    isLoading: false,
    isData: true,
    categoryTotalDisplayType,
  };
};

const SubjectCategoryWithQuery = compose(
  connect(mapStateToProps, mapActionCreators),
  graphql(getOrganizationPointSetQuery, {
    name: "getOrganizationPointSet",
    skip: ({ isCurrentTermInUsedTerms }) => isCurrentTermInUsedTerms,
    options: ({ pointSetVariables }) => ({
      fetchPolicy: "cache-and-network",
      variables: pointSetVariables,
    }),
    props({ getOrganizationPointSet, ownProps: { pointSetVariables } }) {
      const organizationPointSetData = getOrganizationPointSetFromCache({
        variables: pointSetVariables,
      });

      return {
        organizationPointSet: _.get(
          organizationPointSetData,
          "pointAssessmentSets.edges",
          []
        ),
        organizationPointSetCount: _.get(
          organizationPointSetData,
          "pointAssessmentSets.totalCount",
          0
        ),
        isData: !_.isEmpty(organizationPointSetData),
        isLoading: _.includes([1, 2], getOrganizationPointSet.networkStatus),
      };
    },
  }),
  graphql(getSubjectBasedCoursesQuery, {
    name: "getSubjectBasedCourses",
    skip: ({ isCourseApplicableToCategorySet }) =>
      !isCourseApplicableToCategorySet,
    options: ({ subjectBasedCoursesVariables }) => ({
      fetchPolicy: "cache-and-network",
      variables: subjectBasedCoursesVariables,
    }),
    props: ({
      getSubjectBasedCourses,
      ownProps: { subjectBasedCoursesVariables },
    }) => {
      const subjectBasedCourses = getSubjectBasedCoursesFromCache({
        variables: subjectBasedCoursesVariables,
      });

      return {
        getSubjectBasedCourses,
        subjectBasedCourses,
      };
    },
  }),
  graphql(getOrganizationGradeBasicDetailsQuery, {
    name: "getOrganizationGrades",
    skip: ({ isCourseApplicableToCategorySet }) =>
      isCourseApplicableToCategorySet,
    options: ({ organizationId, gradeFilters }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        organizationId,
        filters: gradeFilters,
        portalType: "PLANNER",
      },
    }),
    props({
      getOrganizationGrades: { networkStatus },
      ownProps: { isData, isLoading, organizationId, gradeFilters },
    }) {
      const queryData = getOrganizationBasicGradeDetailsFromCache({
        organizationId,
        filters: gradeFilters,
      });

      return {
        isData: !_.isEmpty(queryData) && isData,
        grades: _.get(queryData, "grades", []),
        isLoading: _.includes([1, 2], networkStatus) || isLoading,
      };
    },
  }),
  withRouter,
  withLoader
)(SubjectCategory);

const SubjectCategoryWithReducer = props => {
  const { initialStateFromProps } = props;
  const initialState = !_.isEmpty(initialStateFromProps)
    ? initialStateFromProps
    : scoreCategoriesInitialState;

  const [state, dispatch] = useReducer(scoreCategoriesReducer, initialState);

  // dispatch functions
  const updateTemplateFieldValue = data => {
    dispatch({ type: UPDATE_TEMPLATE_FIELD_VALUE, data });
  };

  const initTemplateFieldsSet = () => {
    dispatch({ type: INIT_TEMPLATE_FIELDS_SET });
  };

  const updateTemplateFieldsSet = data => {
    dispatch({ type: UPDATE_TEMPLATE_FIELDS_SET, data });
  };

  const setIsEditMode = data => {
    dispatch({
      type: SET_IS_EDIT_TEMPLATE_MODE,
      data,
    });
  };

  const setUsedCourses = data => {
    dispatch({
      type: SET_USED_COURSES,
      data,
    });
  };

  const setUsedCategorySetNames = data => {
    dispatch({
      type: SET_USED_CATEGORY_SET_NAMES,
      data,
    });
  };

  const updateCurrentCategoryGradeBoundaryValues = data => {
    dispatch({ type: UPDATE_CURRENT_CATEGORY_GRADE_BOUNDARY_VALUES, data });
  };

  const updateOverallCategoryGradeBoundaryValues = data => {
    dispatch({ type: UPDATE_OVERALL_CATEGORY_GRADE_BOUNDARY_VALUES, data });
  };

  const dispatchFunctions = {
    updateTemplateFieldValue,
    initTemplateFieldsSet,
    updateTemplateFieldsSet,
    setIsEditMode,
    setUsedCourses,
    setUsedCategorySetNames,
    updateCurrentCategoryGradeBoundaryValues,
    updateOverallCategoryGradeBoundaryValues,
  };

  return (
    <SubjectCategoryWithQuery {...props} {...state} {...dispatchFunctions} />
  );
};

export default SubjectCategoryWithReducer;
